import type { StufenBeschreibung } from '@luzula/luzula-lib';
import { grauTreppe } from './stufen-farbtreppe';

/**
 * Feindurchwurzelung (SEA Teil B) im Grubenprotokoll: Dichte (1a … 6, ein
 * Listenfeld) und Häufung (1 … 4, ein Stufen-Feld).
 *
 * Die Reihen liegen hier, weil zwei Stellen sie brauchen: der Hilfetext am (i)
 * (`feindurchwurzelungHilfetext`) und das Stufen-Feld der Häufung in der
 * Substratfolge (`FEINDURCHWURZELUNG_HAEUFUNG_FELD`).
 */
export const FEINDURCHWURZELUNG_DICHTE: { code: string; name: string }[] = [
	{ code: '1a', name: 'sehr wenig' },
	{ code: '1b', name: 'wenig' },
	{ code: '2a', name: 'mäßig wenig' },
	{ code: '2b', name: 'mäßig' },
	{ code: '3', name: 'mittel' },
	{ code: '4', name: 'viel' },
	{ code: '5', name: 'sehr viel' },
	{ code: '6', name: 'extrem viel' },
];

export const FEINDURCHWURZELUNG_HAEUFUNG: { wert: number; name: string }[] = [
	{ wert: 1, name: 'gleichmäßig' },
	{ wert: 2, name: 'leicht geklumpt' },
	{ wert: 3, name: 'stark geklumpt' },
	{ wert: 4, name: 'auf Flächen / Bahnen konzentriert' },
];

/**
 * Der Hilfetext am (i) — wortgleich mit dem bisherigen Text im Hilfedienst,
 * samt seiner Zeilenaufteilung der Dichte (zwei Paare, dann 3, dann 4 · 5 · 6).
 */
export function feindurchwurzelungHilfetext(): string {
	const d = Object.fromEntries(FEINDURCHWURZELUNG_DICHTE.map(x => [x.code, x.name]));
	const dichte = [
		`  1a — ${d['1a']}     1b — ${d['1b']}`,
		`  2a — ${d['2a']}    2b — ${d['2b']}`,
		`  3 — ${d['3']}`,
		`  4 — ${d['4']} · 5 — ${d['5']} · 6 — ${d['6']}`,
	];
	const haeufung = FEINDURCHWURZELUNG_HAEUFUNG.map(h => `  ${h.wert} — ${h.name}`);
	return 'Feindurchwurzelung — Dichte und Häufung\n\nDichte:\n' + dichte.join('\n') + '\n\nHäufung:\n' + haeufung.join('\n');
}

/** Für das Stufen-Feld der Häufung: keine eigene Legende, deshalb die graue Treppe. */
export const FEINDURCHWURZELUNG_HAEUFUNG_FELD: StufenBeschreibung[] = (() => {
	const farben = grauTreppe(FEINDURCHWURZELUNG_HAEUFUNG.length);
	return FEINDURCHWURZELUNG_HAEUFUNG.map((h, i) => ({ wert: h.wert, farbe: farben[i], name: h.name }));
})();
